var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPurpleBadge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_137_173)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 50,
    r: 35,
    fill: "#7B1FA2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.95 48.2857C43.7702 48.2857 45.25 46.7482 45.25 44.8571C45.25 42.9661 43.7702 41.4286 41.95 41.4286C40.1298 41.4286 38.65 42.9661 38.65 44.8571C38.65 46.7482 40.1298 48.2857 41.95 48.2857ZM65.05 48.2857C66.8702 48.2857 68.35 46.7482 68.35 44.8571C68.35 42.9661 66.8702 41.4286 65.05 41.4286C63.2298 41.4286 61.75 42.9661 61.75 44.8571C61.75 46.7482 63.2298 48.2857 65.05 48.2857ZM66.7 50H63.4C62.4925 50 61.6727 50.3804 61.0745 50.9964C63.1525 52.1804 64.6272 54.3179 64.9469 56.8571H68.35C69.2627 56.8571 70 56.0911 70 55.1429V53.4286C70 51.5375 68.5202 50 66.7 50ZM53.5 50C56.6917 50 59.275 47.3161 59.275 44C59.275 40.6839 56.6917 38 53.5 38C50.3083 38 47.725 40.6839 47.725 44C47.725 47.3161 50.3083 50 53.5 50ZM57.46 51.7143H57.032C55.9595 52.25 54.7684 52.5714 53.5 52.5714C52.2316 52.5714 51.0456 52.25 49.968 51.7143H49.54C46.2606 51.7143 43.6 54.4786 43.6 57.8857V59.4286C43.6 60.8482 44.7086 62 46.075 62H60.925C62.2914 62 63.4 60.8482 63.4 59.4286V57.8857C63.4 54.4786 60.7394 51.7143 57.46 51.7143ZM45.9255 50.9964C45.3273 50.3804 44.5075 50 43.6 50H40.3C38.4798 50 37 51.5375 37 53.4286V55.1429C37 56.0911 37.7373 56.8571 38.65 56.8571H42.048C42.3728 54.3179 43.8475 52.1804 45.9255 50.9964Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_137_173",
    x: 0,
    y: 0,
    width: 110,
    height: 110,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.435294 0 0 0 0 0.258824 0 0 0 0 0.756863 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_137_173"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_137_173",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleBadge);
export default __webpack_public_path__ + "static/media/purpleBadge.1fecc76d9c659d893cfccb3ddaf7a7f9.svg";
export { ForwardRef as ReactComponent };